import { SOUND_EFFECTS } from "../../vendor/src/features/remotion-editor/scripts/sound-effect-data";

// Every bundled sound effect is smaller than this. A base64 source then stays
// below the native document's 4,000,000-character limit for a JSON string.
export const MAX_CATALOG_SOUND_EFFECT_BYTES = 1024 * 1024;

/** Give a bundled catalog sound a source that survives save, re-entry and render. */
export async function catalogSoundEffectSource(
  staticPath: string,
  file: Blob,
): Promise<string> {
  if (!SOUND_EFFECTS.some((sound) => sound.path === staticPath))
    throw new Error("효과음 카탈로그 원본을 확인하지 못했습니다.");
  if (!file.size || file.size > MAX_CATALOG_SOUND_EFFECT_BYTES)
    throw new Error("효과음 원본이 비어 있거나 저장 가능한 크기를 넘었습니다.");

  const bytes = new Uint8Array(await file.arrayBuffer());
  if (!bytes.length || bytes.length > MAX_CATALOG_SOUND_EFFECT_BYTES)
    throw new Error("효과음 원본이 비어 있거나 저장 가능한 크기를 넘었습니다.");
  const isWav = staticPath.endsWith(".wav");
  const matchesWav =
    bytes.length >= 12 &&
    String.fromCharCode(...bytes.subarray(0, 4)) === "RIFF" &&
    String.fromCharCode(...bytes.subarray(8, 12)) === "WAVE";
  const matchesMp3 =
    bytes.length >= 3 &&
    (String.fromCharCode(...bytes.subarray(0, 3)) === "ID3" ||
      (bytes[0] === 0xff && (bytes[1]! & 0xe0) === 0xe0));
  if (isWav ? !matchesWav : !matchesMp3)
    throw new Error("효과음 원본의 파일 형식을 확인하지 못했습니다.");

  let binary = "";
  for (let offset = 0; offset < bytes.length; offset += 8192)
    binary += String.fromCharCode(...bytes.subarray(offset, offset + 8192));
  return `data:${isWav ? "audio/wav" : "audio/mpeg"};base64,${btoa(binary)}`;
}
